/* eslint-disable prettier/prettier */
import clsx from 'clsx';
import { ReactNode } from 'react';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { IconsFill, LocationOutlineIcon } from 'src/svgs/Viagogo';

import * as styles from './VenueNameDisplay.css';

export type VenueNameDisplayProps = {
  venueName?: ReactNode;
  /**
   * The location of the venue (eg. City, State).
   */
  venueLocation?: ReactNode;
  slimMode?: boolean;
  showTitle?: boolean;
  className?: string;
  displayClassName?: string;
  hideIcon?: boolean;
  slimContent?: boolean;
};

export function VenueNameDisplay({
  venueName,
  venueLocation,
  slimMode,
  slimContent,
  className,
  displayClassName,
  showTitle = true,
  hideIcon,
}: VenueNameDisplayProps) {
  return venueName || venueLocation ? (
    <Stack
      gap="m"
      alignItems="center"
      style={{ overflow: slimContent ? 'hidden' : undefined }}
      width={slimMode ? 'full' : undefined}
      className={className}
    >
      {(venueName || venueLocation) && (
        <>
          {!slimMode && !hideIcon && (
            <div className={styles.iconWrapper}>
              <LocationOutlineIcon
                size={vars.iconSize.s}
                fill={IconsFill.textPrimary}
              />
            </div>
          )}
          <Stack
            direction="row"
            flexWrap={slimMode || slimContent ? undefined : 'wrap'}
            className={clsx(styles.venueNameLocation, className, {
              [styles.slimVenueNameLocation]: slimMode,
            })}
          >
            {venueName && (
              <span
                className={clsx(
                  styles.venueName,
                  {
                    [styles.slimVenueName]: slimMode || slimContent,
                  },

                  displayClassName,
                )}
                title={
                  showTitle && typeof venueName === 'string'
                    ? venueName
                    : undefined
                }
              >
                {venueName}
              </span>
            )}
            {venueLocation && (
              <>
                {/* TODO: create a component for joining react components */}
                {venueName && <>&nbsp;&nbsp;</>}
                <span
                  className={clsx(
                    styles.venueLocation,
                    {
                      [styles.slimVenueLocation]: slimMode || slimContent,
                    },
                    displayClassName,
                  )}
                  title={
                    showTitle && typeof venueLocation === 'string'
                      ? venueLocation
                      : undefined
                  }
                >
                  {venueLocation}
                </span>
              </>
            )}
          </Stack>
        </>
      )}
    </Stack>
  ) : null;
}
